import React, { useState } from "react";
import "./Login.css";
import "./variables.css";
import API_URL from "./config";
import useAuthDarkTheme from "./useAuthDarkTheme";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useAuthDarkTheme();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    try {
      const response = await fetch(`${API_URL}/api/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const data = await response.json();
        setError(data.detail || "Something went wrong");
        return;
      }

      setMessage("If this email exists, a reset link has been sent.");
    } catch {
      setError("Server error");
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-container">
        <h2>Forgot Password</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="example@gmail.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button type="submit">Send Reset Link</button>
        </form>

        {error && <p className="error-message">{error}</p>}
        {message && <p className="success-message">{message}</p>}
      </div>
    </div>
  );
};

export default ForgotPassword;